{
    "metric_explainer__title": "Metric definitions",
    "metric_explainer__erp_divergence": "Plato calculates at line level: every order line and every invoice line counts on its own. A partly invoiced order contributes its invoiced lines to revenue. Reports that count only fully invoiced orders arrive at a different figure.",
    "metric_explainer__acl_note": "Figures cover only the customers you may see.",
    "metric__billed__label": "Revenue",
    "metric__billed__definition": "Sum of the invoiced lines, including those of partly invoiced orders. Credit notes reduce revenue. Cancelled lines do not count.",
    "metric__billed__date_basis": "Booked on the invoice date.",
    "metric__billed_wo_credit_note__label": "Revenue (excl. credit notes)",
    "metric__billed_wo_credit_note__definition": "Sum of the invoiced lines, including those of partly invoiced orders, but without credit notes.",
    "metric__billed_wo_credit_note__date_basis": "Booked on the invoice date.",
    "metric__not_billed__label": "Not yet invoiced",
    "metric__not_billed__definition": "Value of the order lines recorded but not yet invoiced. Cancelled and lost lines do not count.",
    "metric__not_billed__date_basis": "Booked on the order entry date.",
    "metric__order_sum__label": "Order intake",
    "metric__order_sum__definition": "Value of all recorded order lines. Cancelled lines do not count.",
    "metric__order_sum__document_types": "Counts the document types {{documentTypes}}.",
    "metric__order_sum__date_basis": "Booked on the order entry date.",
    "metric__gross_margin__label": "Gross margin",
    "metric__gross_margin__definition": "Sum of the gross margin of the lines that make up {{base}}. The ERP supplies the value per line.",
    "metric__gross_margin_percentage__label": "Gross margin %",
    "metric__gross_margin_percentage__definition": "Gross margin of the same lines divided by {{base}}.",
    "metric__units__label": "Quantity",
    "metric__units__definition": "Sum of the line quantities in the unit of measure (UoM) the ERP holds. Different units are added up without conversion.",
    "base__billed": "revenue",
    "base__billed_wo_credit_note": "revenue excluding credit notes",
    "base__not_billed": "the not yet invoiced value",
    "base__order_sum": "order intake",
    "base__order_value": "the order value",
    "base__quote_value": "the quote value",
    "base__selected_figure": "the selected figure",
    "document_type__ORDER": "Order",
    "document_type__CREDITNOTE": "Credit note",
    "document_type__QUOTE": "Quote",
    "document_type__RETURN": "Return",
    "document_type__CONTRACT": "Contract",
    "document_type__DEBIT_MEMO_REQUEST": "Debit memo request",
    "document_type__CREDIT_MEMO_REQUEST": "Credit memo request",
    "saved_views__all_views": "All Views",
    "saved_views__my_views": "My Views",
    "saved_views__shared_views": "Shared Views",
    "saved_views__delete": "Delete",
    "saved_views__delete_confirmation_title": "Delete filter view",
    "saved_views__delete_confirmation_description": "Are you sure you want to delete this filter view? This action cannot be undone.",
    "save_view_dialog__title": "Save view",
    "save_view_dialog__name_placeholder": "Enter name",
    "save_view_dialog__save_button": "Save",
    "saved_views__presets": "Presets",
    "saved_views__save_as_new": "Save as new view…",
    "saved_views__save_error": "The view could not be saved",
    "saved_views__delete_error": "The view could not be deleted",
    "save_view_dialog__share_with_team": "Share with my team",
    "saved_views__more_views": "More views",
    "saved_views__view": "View",
    "saved_views__save_changes": "Save changes",
    "saved_views__revert": "Revert",
    "relative_timestamp__just_now": "just now"
}
